// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"88":"PokemonList","655":"PokedexPokemon"}[chunkId] + "." + {"88":"1a58ed8d","655":"db716948"}[chunkId] + ".css";
};